export default "__VITE_ASSET__c88e41d8__"